module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/commitment-8df08d89f7088f7e9eabfd4627d6ccf2.svg";